<template>
  <v-dialog :value="value" width="95vw" max-width="1600" scrollable persistent @input="$emit('input', $event)">
    <v-card class="exercise-edit-dialog">
      <v-card-title>
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <ValidationObserver ref="formObserver">
          <v-form :disabled="isLoading">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <vee-text-field v-model="item.name" rules="required|max:128" label="Name*" />
                </v-col>
                <!--
                <v-col cols="12" sm="6" v-if="item.category === ExerciseCategory.FITNESS">
                  <vee-select v-model="item.type" :rules="'required'"
                    :items="[''].concat(Object.values(FitnessExercisesSubtype))" label="Subtype*" />
                </v-col>
                -->
                <template v-if="item.category === ExerciseCategory.FITNESS">
                  <v-col cols="12" sm="6">
                    <vee-select v-model="item.type" rules="required"
                                :items="fitnessExerciseTypeOptions"
                                label="Type*"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <vee-select v-model="item.exerciseType" rules="required"
                                :items="[''].concat(Object.values(FitnessRoutinesSubtype))"
                                label="Body Area*"
                    />
                  </v-col>
                </template>

                <v-col v-if="item.category === ExerciseCategory.PRACTICE" cols="12" sm="6">
                  <vee-select v-model="item.type" :rules="'required'"
                              :items="[''].concat(Object.values(PracticeExercisesSubtype))" label="Subtype*"
                  />
                </v-col>

                <v-col v-if="item.category === ExerciseCategory.FLOW" cols="12" sm="6">
                  <vee-select v-model="item.type" :rules="'required'"
                              :items="flowExerciseTypeOptions" label="Type*"
                  />
                </v-col>

                <v-col cols="6" sm="3">
                  <vee-text-field v-model="item.time" rules="required|integer" label="Time (min)*" type="number"
                                  min="0"
                  />
                </v-col>

                <v-col class="d-none d-sm-block" sm="3"></v-col>

                <v-col cols="12" sm="3">
                  <div class="d-flex align-center">
                    <span class="mr-2">Level:</span>
                    <v-slider
                      v-model="item.exerciseLevel"
                      :min="1"
                      :max="5"
                      :step="1"
                      thumb-label
                      ticks
                      tick-size="4"
                      class="mt-5"
                    />
                  </div>
                </v-col>

                <v-col cols="12" sm="3">
                  <v-checkbox v-model="item.active" label="Active" />
                </v-col>

                <v-col cols="12" sm="3">
                  <v-checkbox
                    v-model="item.presentInExercises"
                    :label="presentInExercisesLabel"
                  />
                </v-col>

                <v-col cols="12">
                  <h3>Tags</h3>
                </v-col>

                <v-col cols="12" sm="6">
                  <vee-combobox v-model="item.tags" label="Tags*" :rules="'required|arrayRequired'" multiple small-chips
                                clearable append-icon=""
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <vee-combobox v-model="item.searchTags" label="Search tags*" :rules="'required|arrayRequired'"
                                clearable multiple small-chips append-icon=""
                  />
                </v-col>

                <v-col cols="12">
                  <h3>Thumbnails</h3>
                </v-col>

                <v-col cols="12" class="media-pair-col">
                  <v-row class="media-pair-content">
                    <v-col cols="12" md="6">
                      <upload-file accept="image/*" rules="imageFile" label="Thumbnail file (male)" upload-type="thumb"
                                   @uploadSuccess="updateThumbnail($event.url)"
                      />
                      <vee-text-field :value="item.thumbnail" rules="url|k72url" :clearable="isAdmin" dense outlined :readonly="!isAdmin"
                                      @input="item.thumbnail = $event ? $event : ''"
                      />
                      <v-img-ex v-if="item.thumbnail && item.thumbnail.length" :key="`thumb-male-${forceUpdateCounter}`" :src="item.thumbnail"
                                max-width="120" max-height="120" class="mt-2 mb-2"
                                style="cursor:pointer" @click.native="openImageOverlay(item.thumbnail)"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <upload-file accept="image/*" rules="imageFile" label="Thumbnail file (female)" upload-type="thumb"
                                   @uploadSuccess="updateThumbnailFemale($event.url)"
                      />
                      <vee-text-field :value="item.thumbnailFemale" rules="url|k72url" :clearable="isAdmin" dense outlined :readonly="!isAdmin"
                                      @input="item.thumbnailFemale = $event ? $event : ''"
                      />
                      <v-img-ex v-if="item.thumbnailFemale && item.thumbnailFemale.length" :key="`thumb-female-${forceUpdateCounter}`"
                                :src="item.thumbnailFemale" max-width="120" max-height="120"
                                class="mt-2 mb-2" style="cursor:pointer"
                                @click.native="openImageOverlay(item.thumbnailFemale)"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <h3>Videos</h3>
                </v-col>

                <v-col cols="12" class="media-pair-col">
                  <v-row class="media-pair-content">
                    <v-col cols="12" md="6">
                      <upload-file accept="video/*,video/mp4,video/quicktime,video/x-m4v" rules="videoFile" label="Video file (male)"
                                   @uploadSuccess="updateVideoUrl($event.url)"
                      />
                      <vee-text-field :value="item.video.url" rules="url|k72url" :clearable="isAdmin" dense outlined :readonly="!isAdmin"
                                      @input="item.video.url = $event ? $event : ''"
                      />
                      <template v-if="item.video.url && item.video.url.length">
                        <video :src="item.video.url" height="120" controls class="mt-2 mb-2 cursor-pointer"
                               @click="openVideoOverlay(item.video.url)"
                        />
                      </template>
                    </v-col>

                    <v-col cols="12" md="6">
                      <upload-file accept="video/*,video/mp4,video/quicktime,video/x-m4v" rules="videoFile" label="Video file (female)"
                                   @uploadSuccess="updateVideoFemaleUrl($event.url)"
                      />
                      <vee-text-field :value="item.videoFemale.url" rules="url|k72url" :clearable="isAdmin" dense outlined :readonly="!isAdmin"
                                      @input="item.videoFemale.url = $event ? $event : ''"
                      />
                      <template v-if="item.videoFemale.url && item.videoFemale.url.length">
                        <video :src="item.videoFemale.url" height="120" controls class="mt-2 mb-2 cursor-pointer"
                               @click="openVideoOverlay(item.videoFemale.url)"
                        />
                      </template>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <h3>Instruction</h3>
                </v-col>

                <v-col cols="12" class="media-pair-col">
                  <v-row class="media-pair-content">
                    <v-col cols="12" md="6">
                      <upload-file accept="image/*" rules="imageFile" label="Instruction image url (male)"
                                   @uploadSuccess="updateInstructionImageUrl($event.url)"
                      />
                      <vee-text-field :value="item.instruction.imageUrl" rules="url|k72url" :clearable="isAdmin" dense outlined :readonly="!isAdmin"
                                      @input="item.instruction.imageUrl = $event ? $event : ''"
                      />
                      <v-img-ex v-if="item.instruction.imageUrl && item.instruction.imageUrl.length"
                                :src="item.instruction.imageUrl" max-width="120" max-height="120" class="mt-2 mb-2"
                                style="cursor:pointer" @click.native="openImageOverlay(item.instruction.imageUrl)"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <upload-file accept="image/*" rules="imageFile" label="Instruction image url (female)"
                                   @uploadSuccess="updateInstructionImageUrlFemale($event.url)"
                      />
                      <vee-text-field :value="item.instruction.imageUrlFemale" rules="url|k72url" :clearable="isAdmin" dense outlined :readonly="!isAdmin"
                                      @input="item.instruction.imageUrlFemale = $event ? $event : ''"
                      />
                      <v-img-ex v-if="item.instruction.imageUrlFemale && item.instruction.imageUrlFemale.length"
                                :src="item.instruction.imageUrlFemale" max-width="120" max-height="120" class="mt-2 mb-2"
                                style="cursor:pointer" @click.native="openImageOverlay(item.instruction.imageUrlFemale)"
                      />
                    </v-col>
                  </v-row>

                  <vee-rich-text-editor
                    v-model="item.instruction.description"
                    vid="instructionDescription"
                    label="Description"
                  />
                </v-col>

                <v-col cols="12">
                  <h3>Tips</h3>
                </v-col>

                <v-col cols="12">
                  <v-slide-y-transition group>
                    <v-card v-for="(tip, tipIndex) in item.tips" :key="`tip-${tipIndex}`" class="mb-5" outlined>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <div class="removable-card-header">
                              <v-card-title class="removable-card-header__title pa-0 text-h6">
                                Tip {{ tipIndex + 1 }}/{{ item.tips.length }}
                              </v-card-title>

                              <v-btn icon small class="removable-card-header__delete" @click="onRemoveTip(tipIndex)">
                                <v-icon size="20">
                                  {{ icons.mdiDeleteOutline }}
                                </v-icon>
                              </v-btn>
                            </div>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <vee-text-field v-model="tip.title" :rules="'required|max:128'" label="Title*" />
                            <vee-text-field v-model="tip.subtitle" :rules="'required|max:128'" label="Subtitle*" />
                            <vee-select
                              v-model="tip.type"
                              :vid="`tip-${tipIndex}`"
                              :rules="'required|oneOf:' + Object.values(TipType).join(',')"
                              :items="['', { text: `Do`, value: TipType.DO }, { text: `Don't`, value: TipType.DONT }]"
                              label="Type*"
                            />
                          </v-col>

                          <v-col cols="12" sm="6">
                            <upload-file
                              accept="image/*"
                              rules="imageFile"
                              label="Image url*"
                              @uploadSuccess="updateTipImageUrl(tip, $event.url)"
                            />
                            <vee-text-field
                              :value="tip.imageUrl"
                              rules="required|url|k72url"
                              :clearable="isAdmin"
                              dense
                              outlined
                              label="Image url*"
                              :readonly="!isAdmin"
                              @input="tip.imageUrl = $event ? $event : ''"
                            />
                            <v-img-ex
                              v-if="tip.imageUrl && tip.imageUrl.length"
                              :src="tip.imageUrl"
                              max-width="120"
                              max-height="120"
                              class="mt-2 mb-2"
                              style="cursor:pointer"
                              @click.native="openImageOverlay(tip.imageUrl)"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-slide-y-transition>

                  <v-btn color="primary" class="mb-4" outlined @click="onAddTip">
                    Add tip
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <h3>Detailed instructions</h3>
                </v-col>
                <v-col cols="12">
                  <vee-rich-text-editor v-model="item.details.instructions.title" label="Title" />
                </v-col>

                <v-col cols="12">
                  <v-slide-y-transition group>
                    <v-card v-for="(image, imageIndex) in item.details.instructions.images" :key="`image-${imageIndex}`"
                            class="mb-5" outlined
                    >
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <div class="removable-card-header">
                              <v-card-title class="removable-card-header__title pa-0 text-h6">
                                Image {{ imageIndex + 1 }}/{{ item.details.instructions.images.length }}
                              </v-card-title>

                              <v-btn icon small class="removable-card-header__delete" @click="onRemoveInstructionImage(imageIndex)">
                                <v-icon size="20">
                                  {{ icons.mdiDeleteOutline }}
                                </v-icon>
                              </v-btn>
                            </div>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <vee-text-field v-model="image.title" label="Title" />
                          </v-col>

                          <v-col cols="12">
                            <upload-file accept="image/*" rules="imageFile" label="Image url"
                                         @uploadSuccess="updateImageUrl(image, $event.url)"
                            />
                            <vee-text-field :value="image.imageUrl" :vid="`image-${imageIndex}`"
                                            rules="required|url|k72url" :clearable="isAdmin" dense outlined :readonly="!isAdmin"
                                            @input="image.imageUrl = $event ? $event : ''"
                            />
                            <v-img-ex v-if="image.imageUrl && image.imageUrl.length" :src="image.imageUrl"
                                      max-width="120" max-height="120" class="mt-2 mb-2"
                                      style="cursor:pointer" @click.native="openImageOverlay(image.imageUrl)"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-slide-y-transition>

                  <v-btn color="primary" class="mb-10" outlined @click="onAddInstructionImage">
                    Add instruction image
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <v-checkbox v-model="isAssessment" label="Add assessment" />
                </v-col>

                <template v-if="isAssessment">
                  <template v-if="item.category === ExerciseCategory.FITNESS">
                    <v-col cols="12">
                      <vee-rich-text-editor
                        v-model="item.goal"
                        vid="assessmentGoal"
                        label="Goal"
                      />
                    </v-col>
                    <v-col cols="12">
                      <vee-text-field v-model="item.titleOfSession" :rules="isAssessment ? 'required' : ''" label="Title of session*" />
                    </v-col>
                    <v-col cols="12">
                      <h3>Assessment Tips*</h3>
                    </v-col>
                    <v-col cols="12">
                      <v-slide-y-transition group>
                        <v-card v-for="(tip, tipIndex) in item.assessmentTips" :key="`assessmentTip-${tipIndex}`"
                                class="mb-5" outlined
                        >
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <div class="removable-card-header">
                                  <v-card-title class="removable-card-header__title pa-0 text-h6">
                                    Assessment Tip {{ tipIndex + 1 }}/{{ item.assessmentTips.length }}
                                  </v-card-title>
                                  <v-btn v-if="item.assessmentTips.length > 1" icon small class="removable-card-header__delete"
                                         @click="onRemoveAssessmentTip(tipIndex)"
                                  >
                                    <v-icon size="20">
                                      {{ icons.mdiDeleteOutline }}
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <vee-text-field v-model="tip.title" :rules="'required|max:128'" label="Title*" />
                                <vee-text-field v-model="tip.subtitle" :rules="'max:128'" label="Subtitle" />
                                <vee-select v-model="tip.type" :vid="`assessmentTip-${tipIndex}`"
                                            :rules="'oneOf:' + Object.values(TipType).join(',')"
                                            :items="['', { text: `Do`, value: TipType.DO }, { text: `Don't`, value: TipType.DONT }]"
                                            label="Type"
                                />
                              </v-col>
                              <v-col cols="12" sm="6">
                                <upload-file
                                  accept="image/*"
                                  rules="imageFile"
                                  label="Image url"
                                  @uploadSuccess="updateTipImageUrl(tip, $event.url)"
                                />
                                <vee-text-field
                                  :value="tip.imageUrl"
                                  rules="required|url|k72url"
                                  :clearable="isAdmin"
                                  dense
                                  outlined
                                  label="Image url*"
                                  :readonly="!isAdmin"
                                  @input="tip.imageUrl = $event ? $event : ''"
                                />
                                <v-img-ex
                                  v-if="tip.imageUrl && tip.imageUrl.length"
                                  :src="tip.imageUrl"
                                  max-width="120"
                                  max-height="120"
                                  class="mt-2 mb-2"
                                  style="cursor:pointer"
                                  @click.native="openImageOverlay(tip.imageUrl)"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-slide-y-transition>
                      <v-btn color="primary" class="mb-4" outlined @click="onAddAssessmentTip">
                        Add assessment tip
                      </v-btn>
                    </v-col>
                    <v-col cols="12">
                      <h3>Assessment scoring details*</h3>
                    </v-col>
                    <v-col cols="12">
                      <v-slide-y-transition group>
                        <v-card v-for="(scoringDescription, scoringDescriptionIndex) in item.scoringDescriptions"
                                :key="`scoringDescription-${scoringDescriptionIndex}`" class="mb-5" outlined
                        >
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <div class="removable-card-header">
                                  <v-card-title class="removable-card-header__title pa-0 text-h6">
                                    Scoring description {{ scoringDescriptionIndex + 1 }}/{{
                                      item.scoringDescriptions.length
                                    }}
                                  </v-card-title>
                                  <v-btn v-if="item.scoringDescriptions.length > 1" icon small class="removable-card-header__delete"
                                         @click="onRemoveScoringDescription(scoringDescriptionIndex)"
                                  >
                                    <v-icon size="20">
                                      {{ icons.mdiDeleteOutline }}
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <vee-rich-text-editor
                                  v-model="item.scoringDescriptions[scoringDescriptionIndex].name"
                                  :rules="'required'"
                                  label="Name*"
                                />
                              </v-col>
                              <v-col cols="12" sm="6">
                                <upload-file accept="image/*" rules="imageFile" label="Scoring image*"
                                             upload-type="scoring"
                                             @uploadSuccess="updateScoringImageUrl(item.scoringDescriptions[scoringDescriptionIndex], $event.url)"
                                />
                                <vee-text-field :value="item.scoringDescriptions[scoringDescriptionIndex].image"
                                                rules="required|url|k72url"
                                                :clearable="isAdmin" dense outlined label="Image URL*" :readonly="!isAdmin" @input="item.scoringDescriptions[scoringDescriptionIndex].image = $event ? $event : ''"
                                />
                                <v-img-ex v-if="item.scoringDescriptions[scoringDescriptionIndex].image && item.scoringDescriptions[scoringDescriptionIndex].image.length"
                                          :src="item.scoringDescriptions[scoringDescriptionIndex].image" max-width="120"
                                          max-height="120" class="mt-2 mb-2"
                                          style="cursor:pointer"
                                          @click.native="openImageOverlay(item.scoringDescriptions[scoringDescriptionIndex].image)"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-slide-y-transition>
                      <v-btn color="primary" class="mb-4" outlined @click="onAddScoringDescription">
                        Add scoring description
                      </v-btn>
                    </v-col>
                  </template>
                  <template v-else-if="item.category === ExerciseCategory.PRACTICE">
                    <v-col cols="12">
                      <vee-rich-text-editor
                        v-model="item.goal"
                        vid="assessmentGoal"
                        label="Goal"
                      />
                    </v-col>
                    <v-col cols="12">
                      <vee-text-field v-model="item.titleOfSession" :rules="isAssessment ? 'required' : ''"
                                      label="Title of session*"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <vee-select v-model="item.entryDataMethod" :rules="isAssessment ? 'required' : ''"
                                  :items="entryDataMethodOptions" label="Data Entry Method*" clearable
                      />
                    </v-col>
                    <v-col v-if="shouldShowAttemptsField" cols="12" sm="6">
                      <vee-text-field v-model="item.attempts" :rules="attemptsRules"
                                      :label="attemptsFieldLabel" type="number" min="1"
                      />
                    </v-col>
                    <v-col v-if="shouldShowScoringObjective" cols="12" sm="6">
                      <vee-select v-model="item.distanceUnit" :items="scoringObjectiveOptions" rules="required"
                                  label="Scoring Objective*"
                      />
                    </v-col>
                    <template v-if="shouldShowDistanceFields">
                      <v-col cols="12" sm="6">
                        <vee-text-field v-model="item.distance" :rules="isAssessment ? 'required|integer' : ''"
                                        label="Distance*" type="number" min="1"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <vee-select v-model="item.distanceUnit" :rules="isAssessment ? 'required' : ''"
                                    :items="distanceUnitOptions" label="Distance unit*"
                        />
                      </v-col>
                    </template>
                    <v-col cols="12" sm="6">
                      <vee-select v-model="item.practiceType" :rules="isAssessment ? 'required' : ''"
                                  :items="[''].concat(Object.values(AssessmentPracticeType))" label="Practice type*"
                      />
                    </v-col>
                  </template>
                  <template v-else-if="item.category === ExerciseCategory.FLOW">
                    <v-col cols="12">
                      <vee-rich-text-editor
                        v-model="item.goal"
                        vid="assessmentGoal"
                        label="Goal"
                      />
                    </v-col>
                    <v-col cols="12">
                      <vee-text-field v-model="item.titleOfSession" :rules="isAssessment ? 'required' : ''" label="Title of session*" />
                    </v-col>
                    <v-col cols="12">
                      <h3>Questionnaire*</h3>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" md="6">
                          <vee-text-field
                            v-model="item.questionnaire.title"
                            :rules="isAssessment ? 'required|max:128' : ''"
                            label="Questionnaire title*"
                          />
                        </v-col>
                        <v-col cols="12" md="2">
                          <vee-select
                            v-model="item.questionnaire.whenToFill"
                            :rules="isAssessment ? questionnaireWhenToFillRules : ''"
                            :items="questionnaireWhenToFillOptions"
                            :readonly="item.questionnaire.ratingSource === 'POST_EXERCISE'"
                            label="When to fill*"
                          />
                        </v-col>
                        <v-col cols="12" md="4">
                          <vee-select
                            v-model="item.questionnaire.ratingSource"
                            :rules="isAssessment ? 'required|oneOf:POST_EXERCISE,CATEGORY_QUESTIONNAIRE' : ''"
                            :items="ratingSourceOptions"
                            label="Rating Source*"
                            @input="onRatingSourceChange"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-slide-y-transition group>
                        <v-card
                          v-for="(section, sectionIndex) in activeQuestionnaireQuestions"
                          :key="`questionnaire-section-${sectionIndex}`"
                          class="mb-5"
                          outlined
                        >
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <div class="removable-card-header">
                                  <v-card-title class="removable-card-header__title pa-0 text-h6">
                                    {{ activeQuestionnaireQuestionLabel }} {{ sectionIndex + 1 }}/{{ activeQuestionnaireQuestions.length }}
                                  </v-card-title>
                                  <v-btn v-if="activeQuestionnaireQuestions.length > 1" icon small class="removable-card-header__delete"
                                         @click="onRemoveQuestion(sectionIndex)"
                                  >
                                    <v-icon size="20">
                                      {{ icons.mdiDeleteOutline }}
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </v-col>
                              <template v-if="!isSliderQuestionnaire">
                                <v-col cols="12" class="questionnaire-question-row">
                                  <v-row>
                                    <v-col cols="12" md="10" class="questionnaire-question-text">
                                      <vee-text-field
                                        v-model="section.questionText"
                                        :rules="isAssessment ? 'required|max:256' : ''"
                                        label="Question text*"
                                      />
                                    </v-col>
                                    <v-col cols="12" md="2" class="questionnaire-question-phrasing">
                                      <vee-select
                                        v-model="section.phrasing"
                                        :rules="isAssessment ? 'required|oneOf:positive,negative' : ''"
                                        :items="[
                                          { text: 'Positive', value: 'positive' },
                                          { text: 'Negative', value: 'negative' },
                                        ]"
                                        label="Question Phrasing*"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="12" class="questionnaire-answers">
                                  <h4 class="mb-0">
                                    Answers*
                                  </h4>
                                  <v-row
                                    v-for="(option, optionIndex) in section.choiceList[0].options"
                                    :key="`questionnaire-section-${sectionIndex}-option-${optionIndex}`"
                                    class="questionnaire-answer-row"
                                    align="center"
                                  >
                                    <v-col cols="12" sm="10" class="py-0">
                                      <vee-text-field
                                        v-model="section.choiceList[0].options[optionIndex]"
                                        :rules="isAssessment ? 'required|max:128' : ''"
                                        :label="`Answer ${optionIndex + 1}*`"
                                        dense
                                      />
                                    </v-col>
                                    <v-col cols="12" sm="2" class="py-0">
                                      <v-btn
                                        :disabled="section.choiceList[0].options.length <= 2"
                                        icon
                                        small
                                        @click="onRemoveQuestionOption(sectionIndex, optionIndex)"
                                      >
                                        <v-icon size="20">
                                          {{ icons.mdiDeleteOutline }}
                                        </v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                  <v-btn color="primary" outlined small @click="onAddQuestionOption(sectionIndex)">
                                    Add answer
                                  </v-btn>
                                </v-col>
                              </template>
                              <template v-else>
                                <v-col cols="12" class="questionnaire-question-row">
                                  <v-row>
                                    <v-col cols="12" class="questionnaire-question-text">
                                      <vee-text-field
                                        v-model="section.questionText"
                                        :rules="isAssessment ? 'required|max:256' : ''"
                                        :label="`${activeQuestionnaireQuestionLabel} text*`"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="12" class="questionnaire-question-row">
                                  <v-row>
                                    <v-col cols="12" md="4">
                                      <vee-text-field
                                        v-model="section.startLabel"
                                        :rules="isAssessment ? 'required|max:128' : ''"
                                        label="Start Label*"
                                      />
                                    </v-col>
                                    <v-col cols="12" md="4">
                                      <vee-text-field
                                        v-model="section.endLabel"
                                        :rules="isAssessment ? 'required|max:128' : ''"
                                        label="End Label*"
                                      />
                                    </v-col>
                                    <v-col cols="12" md="2">
                                      <vee-text-field
                                        v-model="section.scaleRange"
                                        :rules="isAssessment ? 'required|integer|between:0,10' : ''"
                                        label="Scale Range* (0-10)"
                                        type="number"
                                        min="0"
                                        max="10"
                                      />
                                    </v-col>
                                    <v-col cols="12" md="2">
                                      <vee-select
                                        v-model="section.scaleType"
                                        :rules="isAssessment ? 'required|oneOf:standard,reversed' : ''"
                                        :items="scaleTypeOptions"
                                        label="Scale Type*"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </template>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-slide-y-transition>
                      <v-btn color="primary" class="mb-4" outlined @click="onAddQuestion">
                        Add {{ isSliderQuestionnaire ? 'slider question' : 'question' }}
                      </v-btn>
                    </v-col>
                  </template>
                </template>
              </v-row>
            </v-container>
          </v-form>
        </ValidationObserver>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="onCancel">
          Cancel
        </v-btn>
        <v-btn text :loading="isLoading" @click="onSave">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiDeleteOutline } from '@mdi/js'
import Vue, {
  computed, ref, nextTick,
} from 'vue'

import { ValidationObserver } from 'vee-validate'
import {
  ExerciseCategory,
  TipType,
  FitnessExercisesSubtype,
  FlowExercisesType,
  PracticeExercisesSubtype,
  AssessmentCategory,
  AssessmentFrequency,
  AssessmentLevel,
  AssessmentPracticeType,
  SessionType, FitnessRoutinesSubtype,
} from '@/enums/enums'
import UploadFile from '@/layouts/components/UploadFile.vue'
import useSnackbar, { SnackbarType } from '@/composables/snackbar'
import VImgEx from '@/components/VImgEx.vue'
import useImageLightBox from '@/composables/imageLightBox'
import useAuth from '@/composables/useAuth'
import { isRichTextEmpty } from '@/utils/richText'

const cleanObject = obj => {
  const clean = { ...obj }

  Object.keys(clean).forEach(key => {
    const value = clean[key]

    if (value === '' || value === null || value === undefined) {
      delete clean[key]
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        delete clean[key]
      } else if (['tips', 'assessmentTips'].includes(key)) {
        clean[key] = value.map(item => (typeof item === 'object' ? cleanObject(item) : item))
        if (clean[key].length === 0) {
          delete clean[key]
        }
      } else {
        clean[key] = value.filter(item => {
          if (typeof item === 'object' && item !== null) {
            const cleanedItem = cleanObject(item)

            return Object.keys(cleanedItem).length > 0
          }

          return item !== '' && item !== null && item !== undefined
        })
        if (clean[key].length === 0) {
          delete clean[key]
        }
      }
    } else if (typeof value === 'object' && value !== null) {
      const cleanedChild = cleanObject(value)

      if (Object.keys(cleanedChild).length === 0) {
        delete clean[key]
      } else {
        clean[key] = cleanedChild
      }
    }
  })

  return clean
}

const ensureExerciseRequiredPayload = item => {
  if (!item.instruction || typeof item.instruction !== 'object') {
    item.instruction = {}
  }

  item.instruction.description = item.instruction.description || ''
  item.instruction.imageUrl = item.instruction.imageUrl || ''
  item.instruction.imageUrlFemale = item.instruction.imageUrlFemale || item.instruction.imageUrl

  return item
}

export default {
  components: {
    UploadFile,
    ValidationObserver,
    VImgEx,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      required: true,
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    FitnessRoutinesSubtype() {
      return FitnessRoutinesSubtype
    },
  },

  setup(props, { emit }) {
    const formObserver = ref(null)
    const isAssessment = ref(false)
    const { showSnackbar } = useSnackbar()
    const { openOverlay: openImageOverlay } = useImageLightBox()
    const { hasRole } = useAuth()
    const isAdmin = computed(() => hasRole(['ADMIN']))

    // Force update counter for reactivity
    const forceUpdateCounter = ref(0)

    const fitnessExerciseTypeOptions = computed(() => [''].concat(
      Object.values(FitnessExercisesSubtype).filter(type => type !== FitnessExercisesSubtype.MENTAL),
    ))

    const flowExerciseTypeOptions = computed(() => [
      '',
      { text: 'Quiet Mind', value: FlowExercisesType.QUIET_MIND },
      { text: 'Breathing', value: FlowExercisesType.BREATHING },
      { text: 'Connection', value: FlowExercisesType.CONNECTION },
      { text: 'Preparation', value: FlowExercisesType.PREPARATION },
      { text: 'Commitment', value: FlowExercisesType.COMMITMENT },
      { text: 'Pressure', value: FlowExercisesType.PRESSURE },
    ])

    const ratingSourceOptions = computed(() => [
      { text: 'Stream A ← Post-exercise', value: 'POST_EXERCISE' },
      { text: 'Stream B ← Category questionnaire', value: 'CATEGORY_QUESTIONNAIRE' },
    ])

    const scaleTypeOptions = computed(() => [
      { text: 'Standard (0-10)', value: 'standard' },
      { text: 'Reversed (10-0)', value: 'reversed' },
    ])

    const questionnaireWhenToFillOptions = computed(() => {
      const ratingSource = props.item.questionnaire?.ratingSource
      if (ratingSource === 'POST_EXERCISE') {
        return [{ text: 'Post-exercise', value: 'post-exercise' }]
      }
      if (ratingSource === 'CATEGORY_QUESTIONNAIRE') {
        return [
          { text: 'Post-round', value: 'post-round' },
          { text: 'Check-in', value: 'check-in' },
        ]
      }

      return []
    })

    const questionnaireWhenToFillRules = computed(() => {
      const ratingSource = props.item.questionnaire?.ratingSource
      if (ratingSource === 'POST_EXERCISE') {
        return 'required|oneOf:post-exercise'
      }
      if (ratingSource === 'CATEGORY_QUESTIONNAIRE') {
        return 'required|oneOf:post-round,check-in'
      }

      return 'required'
    })

    const createBlankQuestionnaireSection = () => ({
      questionText: '',
      phrasing: '',
      choiceList: [
        {
          options: ['', ''],
        },
      ],
    })

    const createBlankSliderQuestion = () => ({
      questionText: '',
      scaleRange: 0,
      scaleType: 'standard',
      startLabel: '',
      endLabel: '',
    })

    const ensureQuestionnaire = () => {
      if (!props.item.questionnaire || typeof props.item.questionnaire !== 'object') {
        Vue.set(props.item, 'questionnaire', {
          title: '',
          questionnaireType: 'Slider',
          whenToFill: '',
          ratingSource: '',
          questions: [createBlankQuestionnaireSection()],
          sliderQuestions: [createBlankSliderQuestion()],
        })
      }

      if (props.item.questionnaire.title === undefined || props.item.questionnaire.title === null) {
        Vue.set(props.item.questionnaire, 'title', '')
      }
      Vue.set(props.item.questionnaire, 'questionnaireType', 'Slider')
      if (props.item.questionnaire.whenToFill === undefined || props.item.questionnaire.whenToFill === null) {
        Vue.set(props.item.questionnaire, 'whenToFill', '')
      }
      if (props.item.questionnaire.ratingSource === undefined || props.item.questionnaire.ratingSource === null) {
        Vue.set(props.item.questionnaire, 'ratingSource', '')
      }
      if (props.item.questionnaire.ratingSource === 'POST_EXERCISE') {
        Vue.set(props.item.questionnaire, 'whenToFill', 'post-exercise')
      }

      if (!Array.isArray(props.item.questionnaire.questions) && Array.isArray(props.item.questionnaire.sections)) {
        Vue.set(props.item.questionnaire, 'questions', props.item.questionnaire.sections)
      }

      if (!Array.isArray(props.item.questionnaire.sections) && Array.isArray(props.item.questionnaire.questions)) {
        Vue.set(props.item.questionnaire, 'sections', props.item.questionnaire.questions)
      }

      if (!Array.isArray(props.item.questionnaire.questions) || props.item.questionnaire.questions.length === 0) {
        Vue.set(props.item.questionnaire, 'questions', [createBlankQuestionnaireSection()])
      }

      if (!Array.isArray(props.item.questionnaire.sliderQuestions) || props.item.questionnaire.sliderQuestions.length === 0) {
        Vue.set(props.item.questionnaire, 'sliderQuestions', [createBlankSliderQuestion()])
      }

      props.item.questionnaire.questions.forEach(section => {
        if (section.questionText === undefined || section.questionText === null) {
          Vue.set(section, 'questionText', '')
        }
        if (section.phrasing === undefined || section.phrasing === null) {
          Vue.set(section, 'phrasing', '')
        }
        if (!Array.isArray(section.choiceList) || section.choiceList.length === 0) {
          Vue.set(section, 'choiceList', [{ options: ['', ''] }])
        }
        if (!Array.isArray(section.choiceList[0].options)) {
          Vue.set(section.choiceList[0], 'options', ['', ''])
        }
        while (section.choiceList[0].options.length < 2) {
          section.choiceList[0].options.push('')
        }
      })

      props.item.questionnaire.sliderQuestions.forEach(section => {
        if (section.questionText === undefined || section.questionText === null) {
          Vue.set(section, 'questionText', '')
        }
        if (section.startLabel === undefined || section.startLabel === null) {
          Vue.set(section, 'startLabel', '')
        }
        if (section.endLabel === undefined || section.endLabel === null) {
          Vue.set(section, 'endLabel', '')
        }
        if (section.scaleRange === undefined || section.scaleRange === null) {
          Vue.set(section, 'scaleRange', 0)
        }
        if (section.scaleType === undefined || section.scaleType === null) {
          Vue.set(section, 'scaleType', 'standard')
        }
      })
    }

    const isSliderQuestionnaire = computed(() => (
      props.item.category === ExerciseCategory.FLOW
      && props.item.questionnaire
    ))

    const activeQuestionnaireQuestions = computed(() => {
      if (!props.item.questionnaire) {
        return []
      }

      return props.item.questionnaire.sliderQuestions
    })

    const activeQuestionnaireQuestionLabel = computed(() => (
      'Slider Question'
    ))

    const onRatingSourceChange = ratingSource => {
      ensureQuestionnaire()
      Vue.set(props.item.questionnaire, 'ratingSource', ratingSource)
      if (ratingSource === 'POST_EXERCISE') {
        Vue.set(props.item.questionnaire, 'whenToFill', 'post-exercise')
      } else if (ratingSource === 'CATEGORY_QUESTIONNAIRE'
        && props.item.questionnaire.whenToFill === 'post-exercise') {
        Vue.set(props.item.questionnaire, 'whenToFill', '')
      }
    }

    // Helper functions to force reactivity with nextTick
    const updateThumbnail = async url => {
      Vue.set(props.item, 'thumbnail', url)
      forceUpdateCounter.value += 1
      await nextTick()
    }

    const updateThumbnailFemale = async url => {
      Vue.set(props.item, 'thumbnailFemale', url)
      forceUpdateCounter.value += 1
      await nextTick()
    }

    const updateVideoUrl = url => {
      if (!props.item.video || typeof props.item.video !== 'object') {
        props.item.video = { url: '' }
      }
      props.item.video.url = url
    }

    const updateVideoFemaleUrl = url => {
      if (!props.item.videoFemale || typeof props.item.videoFemale !== 'object') {
        props.item.videoFemale = { url: '' }
      }
      props.item.videoFemale.url = url
    }

    const updateInstructionImageUrl = url => {
      if (!props.item.instruction || typeof props.item.instruction !== 'object') {
        props.item.instruction = { imageUrl: '', imageUrlFemale: '', description: '' }
      }
      props.item.instruction.imageUrl = url
    }

    const updateInstructionImageUrlFemale = url => {
      if (!props.item.instruction || typeof props.item.instruction !== 'object') {
        props.item.instruction = { imageUrl: '', imageUrlFemale: '', description: '' }
      }
      props.item.instruction.imageUrlFemale = url
    }

    // Universal update functions for tips, images and scoring
    const updateTipImageUrl = (tip, url) => {
      tip.imageUrl = url
    }

    const updateImageUrl = (image, url) => {
      image.imageUrl = url
    }

    const updateScoringImageUrl = (scoringDescription, url) => {
      scoringDescription.image = url
    }

    if (!props.item.video || typeof props.item.video !== 'object') {
      props.item.video = { url: '' }
    }
    if (!props.item.videoFemale || typeof props.item.videoFemale !== 'object') {
      props.item.videoFemale = { url: '' }
    }

    if (!props.item.instruction || typeof props.item.instruction !== 'object') {
      Vue.set(props.item, 'instruction', { imageUrl: '', imageUrlFemale: '', description: '' })
    } else if (props.item.instruction.description === undefined || props.item.instruction.description === null) {
      Vue.set(props.item.instruction, 'description', '')
    }

    if (!props.item.details || typeof props.item.details !== 'object') {
      Vue.set(props.item, 'details', { instructions: { title: '', images: [] } })
    }

    if (!props.item.details.instructions || typeof props.item.details.instructions !== 'object') {
      Vue.set(props.item.details, 'instructions', { title: '', images: [] })
    }

    if (props.item.details.instructions.title === undefined || props.item.details.instructions.title === null) {
      Vue.set(props.item.details.instructions, 'title', '')
    }

    if (!Array.isArray(props.item.details.instructions.images)) {
      Vue.set(props.item.details.instructions, 'images', [])
    }

    if (props.item.active === undefined) {
      props.item.active = true
    }

    if (props.item.presentInExercises === undefined) {
      Vue.set(props.item, 'presentInExercises', false)
    }

    if (!props.item.scoringDescriptions) {
      props.item.scoringDescriptions = []
    }

    if (Array.isArray(props.item.scoringDescriptions)) {
      props.item.scoringDescriptions = props.item.scoringDescriptions.map(desc => {
        if (typeof desc === 'string') {
          return { name: desc, image: '' }
        }

        return desc
      })
    }

    if (props.item.category === ExerciseCategory.FITNESS) {
      if (!Array.isArray(props.item.assessmentTips) || props.item.assessmentTips.length === 0) {
        props.item.assessmentTips = [
          {
            imageUrl: '',
            title: '',
            subtitle: '',
            type: '',
          },
        ]
      }
      if (!Array.isArray(props.item.scoringDescriptions) || props.item.scoringDescriptions.length === 0) {
        props.item.scoringDescriptions = [{
          name: '',
          image: '',
        }]
      }
      if (props.item.goal === undefined || props.item.goal === null) {
        Vue.set(props.item, 'goal', '')
      }
      if (props.item.titleOfSession === undefined || props.item.titleOfSession === null) {
        Vue.set(props.item, 'titleOfSession', '')
      }
      if (props.item.exerciseType === undefined) {
        Vue.set(props.item, 'exerciseType', '')
      }
    }

    if (props.item.category === ExerciseCategory.PRACTICE) {
      if (props.item.goal === undefined || props.item.goal === null) {
        Vue.set(props.item, 'goal', '')
      }
      if (props.item.titleOfSession === undefined || props.item.titleOfSession === null) {
        Vue.set(props.item, 'titleOfSession', '')
      }
      if (!props.item.distanceUnit) {
        props.item.distanceUnit = ''
      }
    }

    if (props.item.category === ExerciseCategory.FLOW) {
      if (props.item.goal === undefined || props.item.goal === null) {
        Vue.set(props.item, 'goal', '')
      }
      if (props.item.titleOfSession === undefined || props.item.titleOfSession === null) {
        Vue.set(props.item, 'titleOfSession', '')
      }
      ensureQuestionnaire()
    }

    const formTitle = computed(() => {
      if (props.item.id === '') {
        if (props.item.category === ExerciseCategory.FITNESS) {
          return 'Create a fitness exercise'
        } if (props.item.category === ExerciseCategory.FLOW) {
          return 'Create a flow exercise'
        } if (props.item.category === ExerciseCategory.PRACTICE) {
          return 'Create a practice drill'
        }

        return 'Create an exercise'
      }
      if (props.item.category === ExerciseCategory.FITNESS) {
        return 'Edit the fitness exercise'
      } if (props.item.category === ExerciseCategory.FLOW) {
        return 'Edit the flow exercise'
      } if (props.item.category === ExerciseCategory.PRACTICE) {
        return 'Edit the practice drill'
      }

      return 'Edit the exercise'
    })

    const presentInExercisesLabel = computed(() => (
      props.item.category === ExerciseCategory.PRACTICE
        ? 'Present in Drills Section in The App'
        : 'Present in Exercises Section in The App'
    ))

    const onAddTip = () => {
      props.item.tips.push({
        imageUrl: '',
        title: '',
        subtitle: '',
        type: '',
      })
    }

    const onRemoveTip = tipIndex => {
      props.item.tips.splice(tipIndex, 1)
    }

    const onAddAssessmentTip = () => {
      props.item.assessmentTips.push({
        imageUrl: '',
        title: '',
        subtitle: '',
        type: '',
      })
    }

    const onRemoveAssessmentTip = tipIndex => {
      props.item.assessmentTips.splice(tipIndex, 1)
    }

    const onAddScoringDescription = () => {
      props.item.scoringDescriptions.push({
        name: '',
        image: '',
      })
    }

    const onRemoveScoringDescription = scoringDescriptionIndex => {
      props.item.scoringDescriptions.splice(scoringDescriptionIndex, 1)
    }

    const onAddQuestion = () => {
      ensureQuestionnaire()
      if (isSliderQuestionnaire.value) {
        props.item.questionnaire.sliderQuestions.push(createBlankSliderQuestion())
      } else {
        props.item.questionnaire.questions.push(createBlankQuestionnaireSection())
      }
    }

    const onRemoveQuestion = sectionIndex => {
      ensureQuestionnaire()
      const questionList = isSliderQuestionnaire.value
        ? props.item.questionnaire.sliderQuestions
        : props.item.questionnaire.questions

      questionList.splice(sectionIndex, 1)
      if (questionList.length === 0) {
        questionList.push(isSliderQuestionnaire.value
          ? createBlankSliderQuestion()
          : createBlankQuestionnaireSection())
      }
    }

    const onAddQuestionOption = sectionIndex => {
      ensureQuestionnaire()
      props.item.questionnaire.questions[sectionIndex].choiceList[0].options.push('')
    }

    const onRemoveQuestionOption = (sectionIndex, optionIndex) => {
      ensureQuestionnaire()
      const { options } = props.item.questionnaire.questions[sectionIndex].choiceList[0]
      if (options.length > 2) {
        options.splice(optionIndex, 1)
      }
    }

    const validateQuestionnaire = questionnaire => {
      if (!questionnaire || !questionnaire.title || !questionnaire.title.trim()) {
        showSnackbar('Questionnaire title is required.', SnackbarType.ERROR)

        return false
      }

      if (!questionnaire.questionnaireType || !questionnaire.questionnaireType.trim()) {
        showSnackbar('Questionnaire type is required.', SnackbarType.ERROR)

        return false
      }
      if (!questionnaire.whenToFill || !questionnaire.whenToFill.trim()) {
        showSnackbar('Questionnaire when to fill is required.', SnackbarType.ERROR)

        return false
      }
      if (!questionnaire.ratingSource || !questionnaire.ratingSource.trim()) {
        showSnackbar('Questionnaire rating source is required.', SnackbarType.ERROR)

        return false
      }
      if (questionnaire.ratingSource === 'POST_EXERCISE') {
        questionnaire.whenToFill = 'post-exercise'
      } else if (questionnaire.ratingSource === 'CATEGORY_QUESTIONNAIRE'
        && !['post-round', 'check-in'].includes(questionnaire.whenToFill)) {
        showSnackbar('Category questionnaire must be filled post-round or as a check-in.', SnackbarType.ERROR)

        return false
      }

      const questionList = questionnaire.questionnaireType === 'Slider'
        ? questionnaire.sliderQuestions
        : questionnaire.questions

      if (!Array.isArray(questionList) || questionList.length === 0) {
        showSnackbar('At least one question is required.', SnackbarType.ERROR)

        return false
      }
      if (questionnaire.questionnaireType === 'Slider' && questionList.length > 3) {
        showSnackbar('A Flow slider questionnaire can have at most three questions.', SnackbarType.ERROR)

        return false
      }

      for (let sectionIndex = 0; sectionIndex < questionList.length; sectionIndex += 1) {
        const section = questionList[sectionIndex]
        const labelPrefix = questionnaire.questionnaireType === 'Slider' ? 'Slider Question' : 'Question'

        if (!section.questionText || !section.questionText.trim()) {
          showSnackbar(`${labelPrefix} ${sectionIndex + 1} text is required.`, SnackbarType.ERROR)

          return false
        }

        if (questionnaire.questionnaireType === 'Slider') {
          if (!section.startLabel || !section.startLabel.trim()) {
            showSnackbar(`Slider Question ${sectionIndex + 1} start label is required.`, SnackbarType.ERROR)

            return false
          }
          if (!section.endLabel || !section.endLabel.trim()) {
            showSnackbar(`Slider Question ${sectionIndex + 1} end label is required.`, SnackbarType.ERROR)

            return false
          }
          const scaleRange = Number(section.scaleRange)
          if (Number.isNaN(scaleRange) || scaleRange < 0 || scaleRange > 10) {
            showSnackbar(`Slider Question ${sectionIndex + 1} scale range must be between 0 and 10.`, SnackbarType.ERROR)

            return false
          }
          if (!section.scaleType || !section.scaleType.trim()) {
            showSnackbar(`Slider Question ${sectionIndex + 1} scale type is required.`, SnackbarType.ERROR)

            return false
          }
        } else if (!section.phrasing || !section.phrasing.trim()) {
          showSnackbar(`Question ${sectionIndex + 1} phrasing is required.`, SnackbarType.ERROR)

          return false
        }

        if (questionnaire.questionnaireType !== 'Slider') {
          const options = section.choiceList?.[0]?.options || []
          const filledOptions = options.filter(option => option && option.trim())
          if (filledOptions.length < 2) {
            showSnackbar(`Question ${sectionIndex + 1} must have at least two answers.`, SnackbarType.ERROR)

            return false
          }
        }
      }

      return true
    }

    const onAddInstructionImage = () => {
      props.item.details.instructions.images.push({
        imageUrl: '',
        title: '',
      })
    }

    const onRemoveInstructionImage = imageIndex => {
      props.item.details.instructions.images.splice(imageIndex, 1)
    }

    const isEditing = props.item.id && props.item.id !== ''
    if (isEditing && props.item.goal && props.item.goal !== '') {
      isAssessment.value = true
    }

    const onCancel = () => {
      emit('cancel')
    }

    const onSave = async () => {
      await nextTick()
      const isValid = await formObserver.value.validate()

      if (isValid) {
        const itemToSave = { ...props.item }
        delete itemToSave.addToGroup
        let normalizedFlowQuestionnaire = null

        if (
          itemToSave.category === ExerciseCategory.PRACTICE
          && itemToSave.entryDataMethod === 'Pass / Fail'
        ) {
          itemToSave.attempts = 0
        }

        const missingRichTextFields = []

        if (!itemToSave.instruction || isRichTextEmpty(itemToSave.instruction.description)) {
          missingRichTextFields.push('description')
        }

        if (isAssessment.value) {
          if (isRichTextEmpty(itemToSave.goal)) {
            missingRichTextFields.push('goal')
          }

          if (itemToSave.category === ExerciseCategory.FITNESS) {
            itemToSave.practiceType = AssessmentPracticeType.EMPTY
          }

          if (itemToSave.category === ExerciseCategory.FLOW) {
            if (!validateQuestionnaire(itemToSave.questionnaire)) {
              return
            }
            itemToSave.practiceType = AssessmentPracticeType.EMPTY
            delete itemToSave.assessmentTips
            delete itemToSave.scoringDescriptions
            delete itemToSave.entryDataMethod
            delete itemToSave.attempts
            delete itemToSave.distance
            delete itemToSave.distanceUnit
          }

          // Remove distance fields for specific data entry methods in PRACTICE assessments
          if (itemToSave.category === ExerciseCategory.PRACTICE) {
            if (itemToSave.entryDataMethod === 'Challenge') {
              delete itemToSave.distance
            } else if (['Goal vs Actual', 'Pass / Fail'].includes(itemToSave.entryDataMethod)) {
              delete itemToSave.distance
              delete itemToSave.distanceUnit
            }
          }
        } else {
          delete itemToSave.goal
          delete itemToSave.titleOfSession

          if (itemToSave.category === ExerciseCategory.FITNESS) {
            delete itemToSave.assessmentTips
            delete itemToSave.scoringDescriptions
          }

          if (itemToSave.category === ExerciseCategory.FLOW) {
            delete itemToSave.questionnaire
            delete itemToSave.assessmentTips
            delete itemToSave.scoringDescriptions
            delete itemToSave.entryDataMethod
            delete itemToSave.attempts
            delete itemToSave.distance
            delete itemToSave.distanceUnit
            delete itemToSave.practiceType
          }

          if (itemToSave.category === ExerciseCategory.PRACTICE) {
            delete itemToSave.entryDataMethod
            delete itemToSave.attempts
            delete itemToSave.distance
            delete itemToSave.distanceUnit
            delete itemToSave.practiceType
          }
        }

        if (missingRichTextFields.length) {
          showSnackbar(
            `The ${missingRichTextFields.join(' and ')} field${missingRichTextFields.length > 1 ? 's are' : ' is'} empty. The exercise will still be saved.`,
            SnackbarType.WARNING,
          )
        }

        if (!itemToSave.instruction) {
          itemToSave.instruction = { imageUrl: '', imageUrlFemale: '', description: '' }
        }
        if (!itemToSave.instruction.imageUrlFemale) {
          itemToSave.instruction.imageUrlFemale = itemToSave.instruction.imageUrl
        }

        if (itemToSave.category === ExerciseCategory.FLOW && itemToSave.questionnaire) {
          if (itemToSave.questionnaire.ratingSource === 'POST_EXERCISE') {
            itemToSave.questionnaire.whenToFill = 'post-exercise'
          }
          const questionnaireType = 'Slider'
          normalizedFlowQuestionnaire = {
            ...itemToSave.questionnaire,
            questionnaireType,
            questions: [],
            sliderQuestions: itemToSave.questionnaire.sliderQuestions || [],
          }

          if (normalizedFlowQuestionnaire.sliderQuestions.length === 0) {
            normalizedFlowQuestionnaire.sliderQuestions = [createBlankSliderQuestion()]
          }
        }

        const cleanedItem = ensureExerciseRequiredPayload(cleanObject(itemToSave))
        if (normalizedFlowQuestionnaire) {
          cleanedItem.questionnaire = normalizedFlowQuestionnaire
        }
        emit('save', cleanedItem)
      } else {
        showSnackbar('Please fill in all required fields before saving.', SnackbarType.ERROR)
      }
    }

    const distanceUnitOptions = computed(() => {
      if (props.item.category !== ExerciseCategory.PRACTICE) return []
      const subtype = props.item.type ? props.item.type.toLowerCase() : ''
      let options = subtype === 'putting'
        ? ['', 'Feet', 'Meters']
        : ['', 'Yards', 'Meters']
      if (props.item.distanceUnit) {
        const found = options.find(
          opt => opt && opt.toLowerCase() === props.item.distanceUnit.toLowerCase(),
        )
        if (found && props.item.distanceUnit !== found) {
          props.item.distanceUnit = found
        } else if (!found) {
          options = options.concat(props.item.distanceUnit)
        }
      }

      return options
    })

    const entryDataMethodOptions = computed(() => [
      'Challenge',
      'Goal vs Actual',
      'Pass / Fail',
      'Distance Spread',
      'Dispersion',
      'Sloping Putts',
      'Driving',
    ])

    const shouldShowDistanceFields = computed(() => {
      const methodsWithoutDistance = ['Challenge', 'Goal vs Actual', 'Pass / Fail']

      return !methodsWithoutDistance.includes(props.item.entryDataMethod)
    })

    const shouldShowAttemptsField = computed(() => props.item.entryDataMethod !== 'Pass / Fail')

    const shouldShowScoringObjective = computed(() => props.item.entryDataMethod === 'Challenge')

    const scoringObjectiveOptions = [
      { text: 'Highest Score', value: 'HIGHEST_SCORE' },
      { text: 'Lowest Score', value: 'LOWEST_SCORE' },
    ]

    const attemptsFieldLabel = computed(() => {
      const method = props.item.entryDataMethod
      switch (method) {
        case 'Challenge':
          return 'Target*'
        case 'Goal vs Actual':
        case 'Pass / Fail':
          return 'Attempts*'
        case 'Distance Spread':
          return 'Target spread value (% of distance - eg 10%)*'
        case 'Dispersion':
          return 'Target spread value (% of distance - eg 10%)*'
        case 'Sloping Putts':
          return 'Number of Attempts per putting type*'
        case 'Driving':
          return 'Attempts*'
        default:
          return 'Attempts*'
      }
    })

    const attemptsRules = computed(() => {
      if (!isAssessment.value) return ''

      return props.item.entryDataMethod === 'Goal vs Actual'
        ? 'required|integer|min_value:1'
        : 'required|integer'
    })

    const openVideoOverlay = url => {
      window.open(url, '_blank')
    }

    return {
      formObserver,
      formTitle,
      presentInExercisesLabel,

      onAddTip,
      onRemoveTip,
      onAddAssessmentTip,
      onRemoveAssessmentTip,
      onAddScoringDescription,
      onRemoveScoringDescription,
      onAddQuestion,
      onRemoveQuestion,
      onAddQuestionOption,
      onRemoveQuestionOption,

      onAddInstructionImage,
      onRemoveInstructionImage,

      onCancel,
      onSave,

      isAssessment,
      isAdmin,

      ExerciseCategory,
      TipType,
      FitnessExercisesSubtype,
      FlowExercisesType,
      fitnessExerciseTypeOptions,
      flowExerciseTypeOptions,
      ratingSourceOptions,
      questionnaireWhenToFillOptions,
      questionnaireWhenToFillRules,
      scaleTypeOptions,
      isSliderQuestionnaire,
      activeQuestionnaireQuestions,
      activeQuestionnaireQuestionLabel,
      PracticeExercisesSubtype,
      SessionType,
      AssessmentLevel,
      AssessmentFrequency,
      AssessmentPracticeType,
      AssessmentCategory,

      icons: {
        mdiDeleteOutline,
      },

      distanceUnitOptions,
      entryDataMethodOptions,
      shouldShowDistanceFields,
      shouldShowAttemptsField,
      shouldShowScoringObjective,
      scoringObjectiveOptions,
      attemptsFieldLabel,
      attemptsRules,
      onRatingSourceChange,
      openVideoOverlay,
      openImageOverlay,
      forceUpdateCounter,
      updateThumbnail,
      updateThumbnailFemale,
      updateVideoUrl,
      updateVideoFemaleUrl,
      updateInstructionImageUrl,
      updateInstructionImageUrlFemale,
      updateTipImageUrl,
      updateImageUrl,
      updateScoringImageUrl,
    }
  },
}
</script>

<style scoped>
.exercise-edit-dialog {
  width: 100%;
}

.removable-card-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.removable-card-header__title {
  flex: 1 1 auto;
  min-width: 0;
}

.removable-card-header__delete {
  flex: 0 0 auto;
}

.media-pair-col {
  max-width: 100%;
  flex-basis: 100%;
}

.media-pair-content {
  max-width: 70%;
}

.questionnaire-answers {
  padding-top: 6px;
}

.questionnaire-question-text {
  padding-bottom: 6px;
}

.questionnaire-question-row {
  padding-bottom: 0;
}

.questionnaire-question-phrasing {
  padding-bottom: 6px;
}

.questionnaire-answer-row {
  margin-top: 14px;
  margin-bottom: 0;
}

@media (max-width: 960px) {
  .media-pair-content {
    max-width: 100%;
  }
}
</style>
